/**
 * Swiper Helper for Ogee 2.0
 * Standardizes Swiper initialization with "Above/Below Fold" optimization support.
 */

if (typeof Swiper !== 'undefined' && typeof Swiper.extendDefaults === 'function') {
  Swiper.extendDefaults({ resizeObserver: false });
}

window.OgeeSwiper = {
  /**
   * Initialize a Swiper instance with optimization
   * @param {HTMLElement} container - The element with class .swiper
   * @param {Object} options - Swiper options
   * @param {Boolean} lazy - If true, uses IntersectionObserver
   * @returns {Swiper|null} - The Swiper instance or null if deferred
   */
  init: function(container, options, lazy) {
    if (!container) return null;
    if (container.swiper || container.dataset.swiperPending === 'true') {
      return container.swiper || null;
    }

    const initFn = () => {
      // Swiper may not be ready in rare cases; retry once on window load.
      if (typeof Swiper === 'undefined') {
        if (container.dataset.swiperPending !== 'load') {
          container.dataset.swiperPending = 'load';
          window.addEventListener('load', initFn, { once: true });
        }
        return null;
      }

      if (container.swiper) {
        delete container.dataset.swiperPending;
        return container.swiper;
      }

      delete container.dataset.swiperPending;
      const swiper = new Swiper(container, {
        resizeObserver: false,
        ...options,
      });
      container.classList.add('swiper-loaded');
      container.dispatchEvent(new CustomEvent('swiper:loaded', { detail: { swiper } }));
      return swiper;
    };

    if (lazy && 'IntersectionObserver' in window) {
      container.dataset.swiperPending = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initFn();
            observer.disconnect();
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(container);
      return null; // Deferred
    } else {
      return initFn();
    }
  }
};
